/**
 * TODO: Consider moving this component to @tickchak/react-share library
 * since it's a generic like/dislike buttons pattern that could be reused across projects.
 */
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import * as css from './LikeDislikeButtons.css';
import ThumbUp from '../../assets/icons/ThumbUp';

type RatingValue = 'like' | 'dislike';

interface LikeDislikeButtonsProps {
    value: RatingValue | null;
    onChange: (rating: RatingValue) => void;
    likeColor?: string;
    dislikeColor?: string;
    likeActiveColor?: string;
    dislikeActiveColor?: string;
    className?: string;
}

function LikeDislikeButtons({
    value,
    onChange,
    likeColor = 'var(--primitive-green-400)',
    dislikeColor = 'var(--primitive-red-400)',
    likeActiveColor = 'white',
    dislikeActiveColor = 'white',
    className
}: LikeDislikeButtonsProps) {
    const {t} = useTranslation('layout');

    const handleClick = (e: React.MouseEvent, rating: RatingValue) => {
        e.stopPropagation();
        onChange(rating);
    };

    return (
        <css.buttonsContainer className={className}>
            <Button 
                className={`feedback-btn like ${value === 'like' ? 'active' : ''}`}
                variant="subtle"
                size="chip"
                onClick={(e) => handleClick(e, 'like')} 
                title={t('yes')}
                iconStart={<ThumbUp fill={value === 'like' ? likeActiveColor : likeColor} />}
                data-testid="like-button"
            />
            <Button 
                className={`feedback-btn dislike ${value === 'dislike' ? 'active' : ''}`}
                variant="subtle"
                size="chip"
                onClick={(e) => handleClick(e, 'dislike')} 
                title={t('no')}
                iconStart={
                    <css.rotatedIcon>
                        <ThumbUp fill={value === 'dislike' ? dislikeActiveColor : dislikeColor} />
                    </css.rotatedIcon>
                }
                data-testid="dislike-button"
            />
        </css.buttonsContainer>
    );
}

export default LikeDislikeButtons;
